import { ROLES_COMING_SOON, SETTINGS_CUSTOMISE_BENEFITS, SETTINGS_CUSTOMISE_BRAND, SETTINGS_CUSTOMISE_CELEBRATIONS, SETTINGS_CUSTOMISE_PERKS_VISIBILITY, SETTINGS_CUSTOMISE_VALUES, SETTINGS_CUSTOMISE_WELCOME_EMAIL, SETTINGS_LOGIN_SSO, SETTINGS_LOGIN_SSU, SETTINGS_PERMISSIONS_RECOGNITION } from "../../../routes/routeConfig";
export default (function (_a) {
    var showPerks = _a.showPerks, showRecognition = _a.showRecognition, showSSO = _a.showSSO;
    return [
        {
            label: "admin.components.companySettingsNav.customise",
            to: SETTINGS_CUSTOMISE_BRAND,
            isCategory: true
        },
        {
            to: SETTINGS_CUSTOMISE_BRAND,
            label: "admin.components.companySettingsNav.brand"
        },
        {
            to: SETTINGS_CUSTOMISE_WELCOME_EMAIL,
            label: "admin.components.companySettingsNav.welcomeEmail"
        },
        showPerks && {
            to: SETTINGS_CUSTOMISE_PERKS_VISIBILITY,
            label: "admin.components.companySettingsNav.perks"
        },
        showPerks && {
            to: SETTINGS_CUSTOMISE_BENEFITS,
            label: "admin.components.companySettingsNav.benefits"
        },
        showRecognition && {
            to: SETTINGS_CUSTOMISE_VALUES,
            label: "admin.components.companySettingsNav.values"
        },
        showRecognition && {
            to: SETTINGS_CUSTOMISE_CELEBRATIONS,
            label: "admin.components.companySettingsNav.celebrations"
        },
        {
            to: showRecognition ? SETTINGS_PERMISSIONS_RECOGNITION : ROLES_COMING_SOON,
            label: "admin.components.companySettingsNav.rolesAndPermissions",
            isCategory: true
        },
        showRecognition && {
            to: SETTINGS_PERMISSIONS_RECOGNITION,
            label: "admin.components.companySettingsNav.recognition"
        },
        {
            to: SETTINGS_LOGIN_SSU,
            label: "admin.components.companySettingsNav.login",
            isCategory: true
        },
        {
            to: SETTINGS_LOGIN_SSU,
            label: "admin.components.companySettingsNav.ssu"
        },
        showSSO && {
            to: SETTINGS_LOGIN_SSO,
            label: "admin.components.companySettingsNav.sso"
        }
    ].filter(function (t) { return !!t; });
});
